import { jsx } from "react/jsx-runtime";
const SvgImportant = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M22 2H2V22L6 18H22V2ZM13 11H11V5H13V11ZM13 15H11V13H13V15Z", fill: "currentColor" }) });
export default SvgImportant;
